
const firebase = require("firebase/app");
                             require("firebase/auth");                 
                             require("firebase/firestore");
                             require("firebase/storage");
                             require("firebase/database");
                             require("firebase/analytics");
const firebaseConfig = {
          apiKey: "AIzaSyAEH5piqrOaZIiTowwM_D4jV48_hVEQ5pM",
          authDomain: "rada-51745.firebaseapp.com",
          databaseURL: "https://rada-51745.firebaseio.com",
          projectId: "rada-51745",
          storageBucket: "rada-51745.appspot.com",
          messagingSenderId: "943475752135",
          appId: "1:943475752135:web:dc0cb994ef56cd458d52e2",
          measurementId: "G-JF63R6YC89"
      };
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const storage = firebase.storage();
const database = firebase.database();
const auth = firebase.auth()

export { firebase,storage,database, auth }